// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"63827c4f45aec93f","8239":"3170f24ede1aac10","8934":"3170f24ede1aac10"}[chunkId] + ".css";
};